import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getValue',
  standalone: true
})
export class GetValuePipe implements PipeTransform {
  transform(value: any, categoryCode: string, featureCode: string): any {
    let newVal: string;
    const feature = value
      .find((cat) => cat.code === categoryCode)
      ?.features?.find((feat) => feat.code === featureCode);
    if (feature !== undefined) {
      if (feature.featureUnit?.symbol) {
        newVal = feature.featureValues[0].value.concat(
          '&nbsp;',
          feature.featureUnit.symbol,
        );
      } else {
        newVal = feature.featureValues[0].value;
      }
    }
    return newVal;
  }
}
